// import React, { useState, useEffect, useMemo, useCallback } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   IconButton,
//   Box,
//   Typography,
//   Avatar,
//   Chip,
//   Button,
//   TextField,
//   Paper,
//   CircularProgress,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Tooltip,
//   InputAdornment,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Grid,
//   LinearProgress,
// } from '@mui/material';
// import { styled, useTheme } from '@mui/material/styles';
// import { useDispatch, useSelector } from 'react-redux';
// import CloseIcon from '@mui/icons-material/Close';
// import RefreshIcon from '@mui/icons-material/Refresh';
// import SearchIcon from '@mui/icons-material/Search';
// import FilterListIcon from '@mui/icons-material/FilterList';
// import ClearIcon from '@mui/icons-material/Clear';
// import DownloadIcon from '@mui/icons-material/Download';
// import TableChartIcon from '@mui/icons-material/TableChart';
// import ScheduleIcon from '@mui/icons-material/Schedule';
// import CommentIcon from '@mui/icons-material/Comment';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import TrendingUpIcon from '@mui/icons-material/TrendingUp';
// import TrendingDownIcon from '@mui/icons-material/TrendingDown';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import FirstPageIcon from '@mui/icons-material/FirstPage';
// import LastPageIcon from '@mui/icons-material/LastPage';
// import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
// import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
// import moment from 'moment';
// import XLSX from '../utils/excelUtils';
// import { Notify } from '../Utility/Notify';
// import { Get_AllComments_For_Sheet_For_Admin_Action } from '../Redux/Actions/MeetingCommentsAction';
// import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
// import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';

// // Styled Components - مبسطة زي المثال بالظبط
// const StyledDialog = styled(Dialog)(({ theme }) => ({
//   '& .MuiDialog-paper': {
//     borderRadius: 16,
//     minWidth: '1000px',
//     maxWidth: '1200px',
//     width: '100%',
//     height: '80vh',
//     display: 'flex',
//     flexDirection: 'column',
//   },
// }));

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   fontWeight: 500,
//   '&.MuiTableCell-head': {
//     backgroundColor:
//       theme.palette.mode === 'dark' ? 'rgba(37, 99, 235, 0.15)' : 'rgba(37, 99, 235, 0.08)',
//     fontWeight: 700,
//   },
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   '&:hover': {
//     backgroundColor:
//       theme.palette.mode === 'dark' ? 'rgba(37, 99, 235, 0.1)' : 'rgba(37, 99, 235, 0.05)',
//   },
// }));

// // Empty State Component
// const EmptyState = ({ mode, onRefresh }) => (
//   <Box sx={{ textAlign: 'center', py: 8, px: 2 }}>
//     <CommentIcon sx={{ fontSize: 80, color: 'text.disabled', mb: 2 }} />
//     <Typography variant="h5" color="text.secondary" gutterBottom>
//       No Comments Found
//     </Typography>
//     <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//       No comments match your filters. Try adjusting your search criteria.
//     </Typography>
//     <Button
//       variant="contained"
//       startIcon={<RefreshIcon />}
//       onClick={onRefresh}
//       sx={{ borderRadius: 8, px: 4 }}
//     >
//       Refresh
//     </Button>
//   </Box>
// );

// export const ShoweetingShwwtForAdmin = ({ open, onClose }) => {
//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const dispatch = useDispatch();

//   // States
//   const [comments, setComments] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [page, setPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [totalCount, setTotalCount] = useState(0);
//   const [totalPages, setTotalPages] = useState(1);
//   const [hasNextPage, setHasNextPage] = useState(false);
//   const [hasPrevPage, setHasPrevPage] = useState(false);
//   const [filterExpanded, setFilterExpanded] = useState(true);

//   // Redux data
//   const rescomments = useSelector((state) => state.AllMeetingComments?.MeetingComments);
//   const resstages = useSelector((state) => state.Allstages?.stage);
//   const ressales = useSelector((state) => state.AllSales?.sales);

//   // Process stages
//   const stagesarray = useMemo(() => {
//     let stages = [];

//     if (resstages?.data && Array.isArray(resstages.data)) {
//       stages = resstages.data;
//     } else if (Array.isArray(resstages)) {
//       stages = resstages;
//     } else if (resstages?.stages && Array.isArray(resstages.stages)) {
//       stages = resstages.stages;
//     }

//     return stages.filter((stage) => ['Meeting', 'EOI', 'Done Deal'].includes(stage?.name));
//   }, [resstages]);

//   // Process sales with userlog ID
//   const salesarray = useMemo(() => {
//     const sales = (Array.isArray(ressales?.data) ? ressales.data : [])
//       .filter(
//         (sale) =>
//           !['Default', 'Default M', 'Default T', 'Default S', 'Developer', 'Dev'].includes(
//             sale?.name,
//           ),
//       )
//       .sort((a, b) => {
//         if (a?.name === 'No Sales') return -1;
//         if (b?.name === 'No Sales') return 1;
//         return (a?.name || '').localeCompare(b?.name || '');
//       });

//     return sales.map((sale) => ({
//       ...sale,
//       userlogId: sale.userlog?._id || sale.userlog || null,
//     }));
//   }, [ressales]);

//   // Filters state
//   const [filters, setFilters] = useState({
//     stage: '',
//     salesUserId: '',
//     salesdeveloperName: '',
//     searchTerm: '',
//     createdFrom: '',
//     createdTo: '',
//   });

//   const [tempFilters, setTempFilters] = useState({ ...filters });

//   // Process comments from Redux
//   useEffect(() => {
//     if (rescomments && open) {
//       console.log('📥 Comments from API:', rescomments);

//       let commentsData = [];
//       let paginationData = {};

//       if (rescomments?.data?.data && Array.isArray(rescomments.data.data)) {
//         commentsData = rescomments.data.data;
//         paginationData = rescomments.data.pagination || {};
//       } else if (rescomments?.data && Array.isArray(rescomments.data)) {
//         commentsData = rescomments.data;
//         paginationData = rescomments.pagination || {};
//       } else if (Array.isArray(rescomments)) {
//         commentsData = rescomments;
//         paginationData = {};
//       } else if (rescomments?.MeetingComments?.data) {
//         commentsData = rescomments.MeetingComments.data || [];
//         paginationData = rescomments.MeetingComments.pagination || {};
//       }

//       setComments(commentsData);

//       const total =
//         paginationData.totalResults || paginationData.total || commentsData?.length || 0;
//       const totalPagesCalc = paginationData.totalPages || Math.ceil(total / rowsPerPage) || 1;

//       setTotalCount(total);
//       setTotalPages(totalPagesCalc);
//       setHasNextPage(paginationData.hasNextPage || page < totalPagesCalc);
//       setHasPrevPage(paginationData.hasPrevPage || page > 1);

//       if (paginationData.page) setPage(paginationData.page);

//       setLoading(false);
//     }
//   }, [rescomments, open, rowsPerPage, page]);

//   // Load initial data when dialog opens
//   useEffect(() => {
//     if (open) {
//       loadInitialData();
//     }
//   }, [open]);

//   const loadInitialData = async () => {
//     setLoading(true);
//     try {
//       await Promise.all([dispatch(GetAll_stage_Data()), dispatch(Get_All_Sales_Action())]);
//       await loadComments(1, filters);
//     } catch (error) {
//       console.error('Error loading initial data:', error);
//       Notify('error', 'Failed to load data', 'error');
//       setLoading(false);
//     }
//   };

//   // Load comments function
//   const loadComments = useCallback(
//     async (pageNum = page, filtersToUse = filters, customRowsPerPage = rowsPerPage) => {
//       setLoading(true);
//       try {
//         const queryParams = new URLSearchParams();

//         queryParams.append('page', pageNum);
//         queryParams.append('limit', customRowsPerPage);

//         if (filtersToUse.stage) queryParams.append('stage', filtersToUse.stage);
//         if (filtersToUse.salesUserId) queryParams.append('salesUserId', filtersToUse.salesUserId);
//         if (filtersToUse.salesdeveloperName)
//           queryParams.append('salesdeveloperName', filtersToUse.salesdeveloperName);

//         if (filtersToUse.searchTerm) {
//           const cleanSearchTerm = filtersToUse.searchTerm.replace(/[+\-\\()]/g, '');
//           queryParams.append('leadName', cleanSearchTerm);
//           queryParams.append('leadPhone', cleanSearchTerm);
//         }

//         if (filtersToUse.createdFrom) queryParams.append('createdFrom', filtersToUse.createdFrom);
//         if (filtersToUse.createdTo) queryParams.append('createdTo', filtersToUse.createdTo);

//         const queryString = queryParams.toString();
//         await dispatch(
//           Get_AllComments_For_Sheet_For_Admin_Action(queryString ? `?${queryString}` : ''),
//         );
//       } catch (error) {
//         console.error('❌ Error loading comments:', error);
//         Notify('error', 'Failed to load comments', 'error');
//         setLoading(false);
//       }
//     },
//     [dispatch],
//   );

//   // Handle filter change
//   const handleFilterChange = (field, value) => {
//     setTempFilters((prev) => ({ ...prev, [field]: value }));
//   };

//   // Apply filters
//   const handleApplyFilters = () => {
//     const cleanFilters = { ...tempFilters };
//     if (cleanFilters.searchTerm) {
//       cleanFilters.searchTerm = cleanFilters.searchTerm.replace(/[+\-\\()]/g, '');
//     }
//     setFilters(cleanFilters);
//     setPage(1);
//     loadComments(1, cleanFilters);
//     Notify('info', 'Filters applied', 'info');
//   };

//   // Clear filters
//   const clearFilters = () => {
//     const emptyFilters = {
//       stage: '',
//       salesUserId: '',
//       salesdeveloperName: '',
//       searchTerm: '',
//       createdFrom: '',
//       createdTo: '',
//     };
//     setTempFilters(emptyFilters);
//     setFilters(emptyFilters);
//     setPage(1);
//     loadComments(1, emptyFilters);
//     Notify('success', 'Filters cleared', 'success');
//   };

//   // Handle page change
//   const handlePageChange = (newPage) => {
//     setPage(newPage);
//     loadComments(newPage, filters);
//   };

//   // Handle rows per page change
//   const handleRowsPerPageChange = (event) => {
//     const newRowsPerPage = parseInt(event.target.value, 10);
//     setRowsPerPage(newRowsPerPage);
//     setPage(1);
//     Notify('info', `Showing ${newRowsPerPage} rows per page`, 'info');
//     loadComments(1, filters, newRowsPerPage);
//   };

//   // Pagination handlers
//   const handleFirstPage = () => page !== 1 && handlePageChange(1);
//   const handleLastPage = () => page !== totalPages && handlePageChange(totalPages);
//   const handlePrevPage = () => hasPrevPage && handlePageChange(page - 1);
//   const handleNextPage = () => hasNextPage && handlePageChange(page + 1);

//   // Export to Excel
//   const exportToExcel = () => {
//     if (comments.length === 0) {
//       Notify('warning', 'No data to export', 'warning');
//       return;
//     }

//     try {
//       const exportData = comments.map((comment) => ({
//         Date: comment.createdAt ? moment(comment.createdAt).format('DD/MM/YYYY HH:mm') : 'N/A',
//         'Lead Name': comment.lead?.name || 'N/A',
//         'Lead Phone': comment.lead?.phone || 'N/A',
//         'Lead Email': comment.lead?.email || 'N/A',
//         Stage: comment.stage?.name || 'N/A',
//         Comment: comment.comment || 'N/A',
//         'Sales (Comment By)': comment.commentBy?.name || 'N/A',
//         'Sales Developer': comment.salesdeveloperName || 'N/A',
//         'Stage Date': comment.stageDate
//           ? moment(comment.stageDate).format('DD/MM/YYYY HH:mm')
//           : 'N/A',
//       }));

//       const ws = XLSX.utils.json_to_sheet(exportData);
//       const wb = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(wb, ws, 'Comments');

//       const fileName = `comments_${moment().format('YYYY-MM-DD_HH-mm')}.xlsx`;
//       XLSX.writeFile(wb, fileName);

//       Notify('success', `Exported ${comments.length} comments`, 'success');
//     } catch (error) {
//       console.error('❌ Export error:', error);
//       Notify('error', 'Failed to export', 'error');
//     }
//   };

//   // Get stage color
//   const getStageColor = (stageName) => {
//     if (!stageName) return '#6b7280';

//     const name = stageName.toLowerCase();
//     if (name.includes('meeting')) return '#f97316';
//     if (name.includes('eoi')) return '#3b82f6';
//     if (name.includes('done')) return '#22c55e';

//     return '#6b7280';
//   };

//   // Get stage icon
//   const getStageIcon = (stageName) => {
//     if (!stageName) return <CommentIcon sx={{ fontSize: 16 }} />;

//     const name = stageName.toLowerCase();
//     if (name.includes('meeting')) return <ScheduleIcon sx={{ fontSize: 16 }} />;
//     if (name.includes('eoi')) return <TrendingUpIcon sx={{ fontSize: 16 }} />;
//     if (name.includes('done')) return <CheckCircleIcon sx={{ fontSize: 16 }} />;

//     return <CommentIcon sx={{ fontSize: 16 }} />;
//   };

//   // Get unique sales developers
//   const salesDevelopersArray = useMemo(() => {
//     if (!comments.length) return [];
//     const uniqueDevelopers = [
//       ...new Set(comments.map((comment) => comment.salesdeveloperName).filter((name) => name)),
//     ];
//     return uniqueDevelopers.sort();
//   }, [comments]);

//   // Active filters count
//   const activeFilterCount = Object.values(filters).filter(
//     (v) => v && v.toString().trim() !== '',
//   ).length;

//   return (
//     <StyledDialog open={open} onClose={onClose}>
//       {/* Header - زي المثال بالظبط */}
//       <DialogTitle
//         sx={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           borderBottom: 1,
//           borderColor: 'divider',
//           bgcolor: mode === 'dark' ? '#1e293b' : '#2563eb',
//           color: 'white',
//           py: 2,
//           px: 3,
//         }}
//       >
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//           <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)' }}>
//             <TableChartIcon />
//           </Avatar>
//           <Box>
//             <Typography variant="h6" fontWeight={600}>
//               Admin Comments Sheet
//             </Typography>
//             <Typography variant="body2" sx={{ opacity: 0.9 }}>
//               Total: {totalCount} comments
//               {activeFilterCount > 0 &&
//                 ` • ${activeFilterCount} filter${activeFilterCount > 1 ? 's' : ''}`}
//             </Typography>
//           </Box>
//         </Box>

//         <Box sx={{ display: 'flex', gap: 1 }}>
//           <Tooltip title="Refresh">
//             <IconButton
//               onClick={() => loadComments(page, filters)}
//               sx={{ color: 'white' }}
//               size="small"
//             >
//               <RefreshIcon />
//             </IconButton>
//           </Tooltip>
//           <Tooltip title="Export to Excel">
//             <IconButton
//               onClick={exportToExcel}
//               disabled={comments.length === 0}
//               sx={{ color: 'white' }}
//               size="small"
//             >
//               <DownloadIcon />
//             </IconButton>
//           </Tooltip>
//           <IconButton onClick={onClose} sx={{ color: 'white' }} size="small">
//             <CloseIcon />
//           </IconButton>
//         </Box>
//       </DialogTitle>

//       {/* Content */}
//       <DialogContent sx={{ p: 3, bgcolor: mode === 'dark' ? '#0f172a' : '#f8fafc' }}>
//         {/* Filters */}
//         <Paper sx={{ p: 2, mb: 3, borderRadius: 2 }}>
//           <Box
//             sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}
//           >
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//               <FilterListIcon sx={{ color: '#2563eb' }} />
//               <Typography variant="h6" fontWeight={600} sx={{ color: '#2563eb' }}>
//                 Filters
//               </Typography>
//             </Box>
//             <IconButton onClick={() => setFilterExpanded(!filterExpanded)} size="small">
//               {filterExpanded ? <TrendingUpIcon /> : <TrendingDownIcon />}
//             </IconButton>
//           </Box>

//           {filterExpanded && (
//             <Grid container spacing={2}>
//               {/* Search */}
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Search by Lead Name or Phone"
//                   value={tempFilters.searchTerm}
//                   onChange={(e) => handleFilterChange('searchTerm', e.target.value)}
//                   placeholder="Enter lead name or phone number..."
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <SearchIcon sx={{ color: '#2563eb' }} />
//                       </InputAdornment>
//                     ),
//                     endAdornment: tempFilters.searchTerm && (
//                       <InputAdornment position="end">
//                         <IconButton
//                           size="small"
//                           onClick={() => handleFilterChange('searchTerm', '')}
//                         >
//                           <ClearIcon fontSize="small" />
//                         </IconButton>
//                       </InputAdornment>
//                     ),
//                   }}
//                 />
//               </Grid>

//               {/* Stage Filter */}
//               <Grid item xs={12} md={4}>
//                 <FormControl fullWidth size="small">
//                   <InputLabel>Stage</InputLabel>
//                   <Select
//                     value={tempFilters.stage || ''}
//                     onChange={(e) => handleFilterChange('stage', e.target.value)}
//                     label="Stage"
//                   >
//                     <MenuItem value="">All Stages</MenuItem>
//                     {stagesarray.map((stage) => (
//                       <MenuItem key={stage._id} value={stage._id}>
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                           <Box
//                             sx={{
//                               width: 12,
//                               height: 12,
//                               borderRadius: '50%',
//                               bgcolor: getStageColor(stage.name),
//                             }}
//                           />
//                           {stage.name}
//                         </Box>
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>

//               {/* Sales Filter */}
//               <Grid item xs={12} md={4}>
//                 <FormControl fullWidth size="small">
//                   <InputLabel>Sales (Comment By)</InputLabel>
//                   <Select
//                     value={tempFilters.salesUserId}
//                     onChange={(e) => handleFilterChange('salesUserId', e.target.value)}
//                     label="Sales (Comment By)"
//                   >
//                     <MenuItem value="">All Sales</MenuItem>
//                     {salesarray.map((sale) => (
//                       <MenuItem key={sale._id} value={sale.userlogId}>
//                         {sale.name}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>

//               {/* Sales Developer Filter */}
//               <Grid item xs={12} md={4}>
//                 <FormControl fullWidth size="small">
//                   <InputLabel>Sales Developer</InputLabel>
//                   <Select
//                     value={tempFilters.salesdeveloperName}
//                     onChange={(e) => handleFilterChange('salesdeveloperName', e.target.value)}
//                     label="Sales Developer"
//                   >
//                     <MenuItem value="">All Developers</MenuItem>
//                     {salesDevelopersArray.map((devName) => (
//                       <MenuItem key={devName} value={devName}>
//                         {devName}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>

//               {/* Created From */}
//               <Grid item xs={12} md={3}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="From Date"
//                   type="date"
//                   value={tempFilters.createdFrom}
//                   onChange={(e) => handleFilterChange('createdFrom', e.target.value)}
//                   InputLabelProps={{ shrink: true }}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <CalendarTodayIcon fontSize="small" sx={{ color: '#2563eb' }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                 />
//               </Grid>

//               {/* Created To */}
//               <Grid item xs={12} md={3}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="To Date"
//                   type="date"
//                   value={tempFilters.createdTo}
//                   onChange={(e) => handleFilterChange('createdTo', e.target.value)}
//                   InputLabelProps={{ shrink: true }}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <CalendarTodayIcon fontSize="small" sx={{ color: '#2563eb' }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                 />
//               </Grid>

//               {/* Buttons */}
//               <Grid item xs={12} md={6}>
//                 <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
//                   <Button
//                     variant="contained"
//                     onClick={handleApplyFilters}
//                     startIcon={<FilterListIcon />}
//                   >
//                     Apply Filters
//                   </Button>
//                   <Button
//                     variant="outlined"
//                     onClick={clearFilters}
//                     startIcon={<ClearIcon />}
//                     disabled={activeFilterCount === 0}
//                   >
//                     Clear
//                   </Button>
//                 </Box>
//               </Grid>
//             </Grid>
//           )}
//         </Paper>

//         {/* Table Section */}
//         {loading ? (
//           <Box sx={{ py: 8, textAlign: 'center' }}>
//             <CircularProgress size={60} thickness={4} sx={{ color: '#2563eb', mb: 2 }} />
//             <Typography>Loading comments...</Typography>
//           </Box>
//         ) : comments.length === 0 ? (
//           <EmptyState mode={mode} onRefresh={() => loadComments(1, filters)} />
//         ) : (
//           <>
//             {/* Results Summary */}
//             <Box
//               sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}
//             >
//               <Typography variant="body2">
//                 Showing {Math.min((page - 1) * rowsPerPage + 1, totalCount)} -{' '}
//                 {Math.min(page * rowsPerPage, totalCount)} of {totalCount} comments
//               </Typography>
//               <Chip
//                 label={`Page ${page} of ${totalPages}`}
//                 size="small"
//                 sx={{ bgcolor: '#2563eb', color: 'white' }}
//               />
//             </Box>

//             {/* Table */}
//             <TableContainer component={Paper} sx={{ borderRadius: 2, overflow: 'hidden' }}>
//               <Table stickyHeader size="small">
//                 <TableHead>
//                   <TableRow>
//                     <StyledTableCell>Date</StyledTableCell>
//                     <StyledTableCell>Lead Info</StyledTableCell>
//                     <StyledTableCell>Stage</StyledTableCell>
//                     <StyledTableCell>Comment</StyledTableCell>
//                     <StyledTableCell>Sales (Comment By)</StyledTableCell>
//                     <StyledTableCell>Sales Developer</StyledTableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {comments.map((comment, index) => (
//                     <StyledTableRow key={comment._id || index}>
//                       <StyledTableCell>
//                         <Typography variant="body2" fontWeight={600}>
//                           {moment(comment.createdAt).format('DD/MM/YYYY')}
//                         </Typography>
//                         <Typography variant="caption" color="textSecondary">
//                           {moment(comment.createdAt).format('hh:mm A')}
//                         </Typography>
//                       </StyledTableCell>

//                       <StyledTableCell>
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                           <Avatar
//                             sx={{ width: 32, height: 32, bgcolor: '#2563eb', fontSize: '0.875rem' }}
//                           >
//                             {comment.lead?.name?.charAt(0)?.toUpperCase() || '?'}
//                           </Avatar>
//                           <Box>
//                             <Typography variant="body2" fontWeight={600}>
//                               {comment.lead?.name || 'N/A'}
//                             </Typography>
//                             {comment.lead?.phone && (
//                               <Typography variant="caption" color="textSecondary">
//                                 {comment.lead.phone}
//                               </Typography>
//                             )}
//                           </Box>
//                         </Box>
//                       </StyledTableCell>

//                       <StyledTableCell>
//                         <Chip
//                           icon={getStageIcon(comment.stage?.name)}
//                           label={comment.stage?.name || 'N/A'}
//                           size="small"
//                           sx={{
//                             bgcolor: getStageColor(comment.stage?.name),
//                             color: 'white',
//                             fontWeight: 600,
//                             '& .MuiChip-icon': { color: 'white' },
//                           }}
//                         />
//                       </StyledTableCell>

//                       <StyledTableCell>
//                         <Tooltip title={comment.comment || ''} arrow>
//                           <Typography
//                             variant="body2"
//                             sx={{
//                               maxWidth: 200,
//                               overflow: 'hidden',
//                               textOverflow: 'ellipsis',
//                               whiteSpace: 'nowrap',
//                             }}
//                           >
//                             {comment.comment || 'N/A'}
//                           </Typography>
//                         </Tooltip>
//                       </StyledTableCell>

//                       <StyledTableCell>
//                         <Typography variant="body2" fontWeight={500}>
//                           {comment.commentBy?.name || 'N/A'}
//                         </Typography>
//                       </StyledTableCell>

//                       <StyledTableCell>
//                         <Typography variant="body2" fontWeight={500}>
//                           {comment.salesdeveloperName || 'N/A'}
//                         </Typography>
//                       </StyledTableCell>
//                     </StyledTableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>

//             {/* Pagination */}
//             <Box
//               sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}
//             >
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <Typography variant="body2">Rows per page:</Typography>
//                 <Select
//                   value={rowsPerPage}
//                   onChange={handleRowsPerPageChange}
//                   size="small"
//                   sx={{ minWidth: 80 }}
//                 >
//                   {[5, 10, 25, 50, 100].map((option) => (
//                     <MenuItem key={option} value={option}>
//                       {option}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </Box>

//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <IconButton onClick={handleFirstPage} disabled={page === 1} size="small">
//                   <FirstPageIcon />
//                 </IconButton>
//                 <IconButton onClick={handlePrevPage} disabled={!hasPrevPage} size="small">
//                   <KeyboardArrowLeftIcon />
//                 </IconButton>
//                 <Typography sx={{ mx: 1 }}>
//                   Page {page} of {totalPages}
//                 </Typography>
//                 <IconButton onClick={handleNextPage} disabled={!hasNextPage} size="small">
//                   <KeyboardArrowRightIcon />
//                 </IconButton>
//                 <IconButton onClick={handleLastPage} disabled={page === totalPages} size="small">
//                   <LastPageIcon />
//                 </IconButton>
//               </Box>
//             </Box>
//           </>
//         )}
//       </DialogContent>
//     </StyledDialog>
//   );
// };















// 20-5-2026
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import {
  Box, Typography, Avatar, Button, TextField,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Tooltip, InputAdornment, FormControl, Select, MenuItem,
  Grid, LinearProgress, IconButton, Fade,
} from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import CloseIcon              from '@mui/icons-material/Close';
import RefreshIcon            from '@mui/icons-material/Refresh';
import SearchIcon             from '@mui/icons-material/Search';
import FilterListIcon         from '@mui/icons-material/FilterList';
import ClearIcon              from '@mui/icons-material/Clear';
import DownloadIcon           from '@mui/icons-material/Download';
import TableChartIcon         from '@mui/icons-material/TableChart';
import CommentIcon            from '@mui/icons-material/Comment';
import FirstPageIcon          from '@mui/icons-material/FirstPage';
import LastPageIcon           from '@mui/icons-material/LastPage';
import KeyboardArrowLeftIcon  from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import AssessmentIcon         from '@mui/icons-material/Assessment';
import PeopleAltIcon          from '@mui/icons-material/PeopleAlt';
import moment from 'moment';
import XLSX   from '../utils/excelUtils';
import { Notify } from '../Utility/Notify';
import { useSidebarWidth } from '../Utility/useSidebarWidth';
import { Get_AllComments_For_Sheet_For_Admin_Action } from '../Redux/Actions/MeetingCommentsAction';
import { Get_All_Sales_Action }                       from '../Redux/Actions/SalesAction';
import { GetAll_stage_Data }                          from '../Redux/Actions/Stage_Action';
import { SearchableDropdown } from '../Utility/SearchableDropdown';

// ══════════════════════════════════════════════════════════════
//  Styled Components
// ══════════════════════════════════════════════════════════════

const PanelHeader = styled(Box)(({ theme }) => ({
  background: theme.palette.mode === 'dark'
    ? 'linear-gradient(135deg, #0d1b3e 0%, #1a2a5e 100%)'
    : 'linear-gradient(135deg, #1e3a8a 0%, #1d4ed8 100%)',
  padding: theme.spacing(2.5, 3.5),
  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
  flexShrink: 0, position: 'relative', overflow: 'hidden',
  '&::after':  { content: '""', position: 'absolute', top: '-40px',  right: '-40px',  width: 180, height: 180, borderRadius: '50%', background: 'rgba(255,255,255,0.05)' },
  '&::before': { content: '""', position: 'absolute', bottom: '-60px', right: '120px', width: 140, height: 140, borderRadius: '50%', background: 'rgba(255,255,255,0.04)' },
}));

const StatCard = styled(Box)(({ theme }) => ({
  background: theme.palette.mode === 'dark' ? '#1e2132' : '#ffffff',
  borderRadius: 12,
  border: `1px solid ${theme.palette.mode === 'dark' ? '#2a2f45' : '#e2e8f0'}`,
  padding: theme.spacing(2),
  display: 'flex', alignItems: 'center', gap: 12,
  transition: 'all 0.2s ease',
  '&:hover': {
    borderColor: '#1d4ed8',
    transform: 'translateY(-1px)',
    boxShadow: theme.palette.mode === 'dark'
      ? '0 4px 20px rgba(0,0,0,0.3)'
      : '0 4px 20px rgba(29,78,216,0.1)',
  },
}));

const FilterPanel = styled(Box)(({ theme }) => ({
  background: theme.palette.mode === 'dark' ? '#161929' : '#f8fafc',
  borderRadius: 12,
  border: `1px solid ${theme.palette.mode === 'dark' ? '#2a2f45' : '#e2e8f0'}`,
  padding: theme.spacing(2.5),
  marginBottom: theme.spacing(2),
}));

const StageTag = styled(Box)(({ chipcolor }) => ({
  display: 'inline-flex', alignItems: 'center', gap: 4,
  padding: '2px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700, letterSpacing: 0.4,
  backgroundColor: chipcolor + '18', color: chipcolor,
  border: `1px solid ${chipcolor}35`, whiteSpace: 'nowrap',
}));

const NavBtn = styled(IconButton)(({ theme }) => ({
  width: 30, height: 30, borderRadius: 6,
  border: `1px solid ${theme.palette.mode === 'dark' ? '#2a2f45' : '#e2e8f0'}`,
  background: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.04)' : '#ffffff',
  color: theme.palette.mode === 'dark' ? '#94a3b8' : '#64748b',
  '&:hover': { background: '#1d4ed8', borderColor: '#1d4ed8', color: '#ffffff' },
  '&.Mui-disabled': { opacity: 0.35 },
  transition: 'all 0.15s ease',
}));

const PgBtn = styled(Button)(({ theme, isactive }) => ({
  minWidth: 32, height: 32, borderRadius: 6, padding: 0, fontWeight: 600, fontSize: 13,
  transition: 'all 0.15s ease',
  ...(isactive === 'true'
    ? {
        background: 'linear-gradient(135deg, #1e3a8a, #1d4ed8)',
        color: '#ffffff', border: 'none',
        boxShadow: '0 2px 8px rgba(29,78,216,0.35)',
        '&:hover': { background: 'linear-gradient(135deg, #1e3a8a, #2563eb)' },
      }
    : {
        background: 'transparent',
        color: theme.palette.mode === 'dark' ? '#94a3b8' : '#64748b',
        border: `1px solid ${theme.palette.mode === 'dark' ? '#2a2f45' : '#e2e8f0'}`,
        '&:hover': { borderColor: '#1d4ed8', color: '#1d4ed8', background: 'rgba(29,78,216,0.06)' },
      }),
}));

// ══════════════════════════════════════════════════════════════
//  Main Component
// ══════════════════════════════════════════════════════════════

export const ShoweetingShwwtForAdmin = ({ open, onClose }) => {
  const theme        = useTheme();
  const isDark       = theme.palette.mode === 'dark';
  const dispatch     = useDispatch();
  const sidebarWidth = useSidebarWidth();

  const [comments,    setComments]    = useState([]);
  const [loading,     setLoading]     = useState(false);
  const [page,        setPage]        = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount,  setTotalCount]  = useState(0);
  const [totalPages,  setTotalPages]  = useState(1);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [hasPrevPage, setHasPrevPage] = useState(false);
  const [filterOpen,  setFilterOpen]  = useState(true);

  const rescomments = useSelector((s) => s.AllMeetingComments?.MeetingComments);
  const resstages   = useSelector((s) => s.Allstages?.stage);
  const ressales    = useSelector((s) => s.AllSales?.sales);

  const getStageColor = (name) => {
    if (!name) return '#6b7280';
    const n = name.toLowerCase();
    if (n.includes('meeting')) return '#f97316';
    if (n.includes('eoi'))     return '#1d4ed8';
    if (n.includes('done'))    return '#16a34a';
    return '#6b7280';
  };

  const stagesarray = useMemo(() => {
    let s = [];
    if (resstages?.data && Array.isArray(resstages.data))          s = resstages.data;
    else if (Array.isArray(resstages))                             s = resstages;
    else if (resstages?.stages && Array.isArray(resstages.stages)) s = resstages.stages;
    return s.filter((x) => ['Meeting', 'EOI', 'Done Deal'].includes(x?.name));
  }, [resstages]);

  const salesarray = useMemo(() => {
    const s = (Array.isArray(ressales?.data) ? ressales.data : [])
      .filter((x) => !['Default', 'Default M', 'Default T', 'Default S', 'Developer', 'Dev'].includes(x?.name))
      .sort((a, b) => {
        if (a?.name === 'No Sales') return -1;
        if (b?.name === 'No Sales') return 1;
        return (a?.name || '').localeCompare(b?.name || '');
      });
    return s.map((x) => ({ ...x, userlogId: x.userlog?._id || x.userlog || null }));
  }, [ressales]);

  const emptyFilters = {
    stage: '', salesUserId: '', salesdeveloperName: '',
    searchTerm: '', createdFrom: '', createdTo: '',
  };
  const [filters,     setFilters]     = useState({ ...emptyFilters });
  const [tempFilters, setTempFilters] = useState({ ...emptyFilters });

  const salesDevelopersArray = useMemo(() => {
    if (!comments.length) return [];
    return [...new Set(comments.map((c) => c.salesdeveloperName).filter(Boolean))].sort();
  }, [comments]);

  const activeFilterCount = Object.values(filters).filter((v) => v && v.toString().trim() !== '').length;

  // ── Dropdown options ──────────────────────────────────────────

  const stageOptions = useMemo(() => [
    { value: '', label: 'All Stages', sublabel: 'Show all comments', avatarColor: '#6b7280' },
    ...stagesarray.map((s) => ({
      value:   s._id,
      label:   s.name,
      sublabel: `Filter by ${s.name}`,
      dot:     getStageColor(s.name), // colored dot بدل avatar
    })),
  ], [stagesarray]); // eslint-disable-line

  const salesOptions = useMemo(() => [
    { value: '', label: 'All Sales', sublabel: 'Show all comments', avatarColor: '#6b7280' },
    ...salesarray.map((s) => ({
      value:       s.userlogId,
      label:       s.name,
      sublabel:    s.role || 'Sales Representative',
      avatarColor: '#0f766e',
    })),
  ], [salesarray]);

  const devOptions = useMemo(() => [
    { value: '', label: 'All Developers', sublabel: 'Show all', avatarColor: '#6b7280' },
    ...salesDevelopersArray.map((d) => ({
      value:       d,
      label:       d,
      sublabel:    'Sales Developer',
      avatarColor: '#7c3aed',
    })),
  ], [salesDevelopersArray]);

  // ── Process redux comments response ──────────────────────────

  useEffect(() => {
    if (!rescomments || !open) return;
    let commentsData = [], paginationData = {};

    if (rescomments?.data?.data && Array.isArray(rescomments.data.data)) {
      commentsData   = rescomments.data.data;
      paginationData = rescomments.data.pagination || {};
    } else if (rescomments?.data && Array.isArray(rescomments.data)) {
      commentsData   = rescomments.data;
      paginationData = rescomments.pagination || {};
    } else if (Array.isArray(rescomments)) {
      commentsData = rescomments;
    } else if (rescomments?.MeetingComments?.data) {
      commentsData   = rescomments.MeetingComments.data || [];
      paginationData = rescomments.MeetingComments.pagination || {};
    }

    setComments(commentsData);
    const total          = paginationData.totalResults || paginationData.total || commentsData.length || 0;
    const totalPagesCalc = paginationData.totalPages || Math.ceil(total / rowsPerPage) || 1;
    setTotalCount(total);
    setTotalPages(totalPagesCalc);
    setHasNextPage(paginationData.hasNextPage || page < totalPagesCalc);
    setHasPrevPage(paginationData.hasPrevPage || page > 1);
    if (paginationData.page) setPage(paginationData.page);
    setLoading(false);
  }, [rescomments, open, rowsPerPage, page]);

  useEffect(() => {
    if (open) {
      setFilters({ ...emptyFilters });
      setTempFilters({ ...emptyFilters });
      setPage(1);
      loadInitialData();
    }
  }, [open]); // eslint-disable-line

  const loadInitialData = async () => {
    setLoading(true);
    try {
      await Promise.all([dispatch(GetAll_stage_Data()), dispatch(Get_All_Sales_Action())]);
      await loadComments(1, emptyFilters);
    } catch (err) {
      console.error(err);
      Notify('error', 'Failed to load', 'error');
      setLoading(false);
    }
  };

  const loadComments = useCallback(
    async (pageNum = page, filtersToUse = filters, customLimit = rowsPerPage) => {
      setLoading(true);
      try {
        const q = new URLSearchParams();
        q.append('page',  pageNum);
        q.append('limit', customLimit);
        if (filtersToUse.stage)              q.append('stage',              filtersToUse.stage);
        if (filtersToUse.salesUserId)        q.append('salesUserId',        filtersToUse.salesUserId);
        if (filtersToUse.salesdeveloperName) q.append('salesdeveloperName', filtersToUse.salesdeveloperName);
        if (filtersToUse.searchTerm) {
          const c = filtersToUse.searchTerm.replace(/[+\-\\()]/g, '');
          q.append('leadName',  c);
          q.append('leadPhone', c);
        }
        if (filtersToUse.createdFrom) q.append('createdFrom', filtersToUse.createdFrom);
        if (filtersToUse.createdTo)   q.append('createdTo',   filtersToUse.createdTo);
        await dispatch(Get_AllComments_For_Sheet_For_Admin_Action(`?${q.toString()}`));
      } catch (err) {
        console.error(err);
        Notify('error', 'Failed to load', 'error');
        setLoading(false);
      }
    },
    [dispatch], // eslint-disable-line
  );

  const handleFilterChange    = (f, v) => setTempFilters((p) => ({ ...p, [f]: v }));
  const handleApplyFilters    = () => {
    const clean = { ...tempFilters, searchTerm: tempFilters.searchTerm.replace(/[+\-\\()]/g, '') };
    setFilters(clean); setPage(1); loadComments(1, clean);
  };
  const clearFilters          = () => {
    setTempFilters({ ...emptyFilters });
    setFilters({ ...emptyFilters });
    setPage(1);
    loadComments(1, emptyFilters);
  };
  const handlePageChange      = (n)  => { setPage(n); loadComments(n, filters); };
  const handleRowsPerPageChange = (e) => {
    const n = parseInt(e.target.value, 10);
    setRowsPerPage(n); setPage(1); loadComments(1, filters, n);
  };

  const exportToExcel = () => {
    if (!comments.length) { Notify('warning', 'No data', 'warning'); return; }
    try {
      const ws = XLSX.utils.json_to_sheet(comments.map((c) => ({
        Date:      c.createdAt ? moment(c.createdAt).format('DD/MM/YYYY HH:mm') : 'N/A',
        Lead:      c.lead?.name  || 'N/A',
        Phone:     c.lead?.phone || 'N/A',
        Stage:     c.stage?.name || 'N/A',
        Comment:   c.comment     || 'N/A',
        Sales:     c.commentBy?.name       || 'N/A',
        Developer: c.salesdeveloperName    || 'N/A',
      })));
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Comments');
      XLSX.writeFile(wb, `comments_${moment().format('YYYY-MM-DD')}.xlsx`);
      Notify('success', `Exported ${comments.length} rows`, 'success');
    } catch {
      Notify('error', 'Export failed', 'error');
    }
  };

  const getPageNumbers = () => {
    const delta = 2, range = [], out = []; let l;
    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= page - delta && i <= page + delta)) range.push(i);
    }
    range.forEach((i) => {
      if (l) { if (i - l === 2) out.push(l + 1); else if (i - l !== 1) out.push('...'); }
      out.push(i); l = i;
    });
    return out;
  };

  const menuProps = {
    sx: { zIndex: 60000 },
    PaperProps: { sx: { zIndex: 60000, borderRadius: 2, mt: 0.5 } },
  };

  const inputSx = (isDk) => ({
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px', fontSize: 13,
      backgroundColor: isDk ? '#0f1117' : '#ffffff',
      '& fieldset': { borderColor: isDk ? '#2a2f45' : '#e2e8f0' },
      '&:hover fieldset': { borderColor: '#1d4ed8' },
      '&.Mui-focused fieldset': { borderColor: '#1d4ed8', borderWidth: 2 },
    },
  });

  const selectSx = (isDk) => ({
    borderRadius: '8px', fontSize: 13,
    backgroundColor: isDk ? '#0f1117' : '#ffffff',
    '& .MuiOutlinedInput-notchedOutline': { borderColor: isDk ? '#2a2f45' : '#e2e8f0' },
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#1d4ed8' },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1d4ed8' },
  });

  const bg     = isDark ? '#0d0f1a' : '#f0f2f7';
  const cardBg = isDark ? '#1a1d2e' : '#ffffff';
  const border = isDark ? '#2a2f45' : '#e2e8f0';
  const txtPri = isDark ? '#f1f5f9' : '#0f172a';
  const txtSec = isDark ? '#94a3b8' : '#64748b';

  const stageSummary = useMemo(() => {
    const map = {};
    comments.forEach((c) => { const n = c.stage?.name; if (n) map[n] = (map[n] || 0) + 1; });
    return Object.entries(map);
  }, [comments]);

  // ── Render ────────────────────────────────────────────────────

  return (
    <>
      {/* Backdrop */}
      <Fade in={open}>
        <Box
          onClick={onClose}
          sx={{
            position: 'fixed', inset: 0, zIndex: 49998,
            background: 'rgba(0,0,0,0.45)', backdropFilter: 'blur(3px)',
          }}
        />
      </Fade>

      {/* Panel */}
      <Box sx={{
        position: 'fixed', top: '50px',
        left: open ? sidebarWidth : '100vw',
        right: 0, bottom: 0,
        zIndex: 49999,
        display: 'flex', flexDirection: 'column', overflow: 'hidden',
        background: bg,
        fontFamily: "'DM Sans','Segoe UI',sans-serif",
        transition: 'left 0.35s cubic-bezier(0.4,0,0.2,1)',
      }}>

        {/* ── Header ── */}
        <PanelHeader>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, position: 'relative', zIndex: 1 }}>
            <Box sx={{
              width: 46, height: 46, borderRadius: 3,
              background: 'rgba(255,255,255,0.12)',
              border: '1px solid rgba(255,255,255,0.18)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              backdropFilter: 'blur(8px)',
            }}>
              <AssessmentIcon sx={{ fontSize: 22, color: '#fff' }} />
            </Box>
            <Box>
              <Typography sx={{ fontSize: 18, fontWeight: 800, color: '#fff', letterSpacing: -0.4, lineHeight: 1.2 }}>
                Admin Comments Sheet
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mt: 0.4 }}>
                <Typography sx={{ fontSize: 12, color: 'rgba(255,255,255,0.65)' }}>
                  {totalCount} total comments
                </Typography>
                {activeFilterCount > 0 && (
                  <Box sx={{ px: 1, py: 0.2, borderRadius: 10, background: 'rgba(255,255,255,0.15)', fontSize: 11, color: '#fff', fontWeight: 600 }}>
                    {activeFilterCount} filter{activeFilterCount > 1 ? 's' : ''} active
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', gap: 1, position: 'relative', zIndex: 1 }}>
            <Button
              startIcon={<DownloadIcon sx={{ fontSize: 16 }} />}
              onClick={exportToExcel}
              disabled={!comments.length}
              sx={{
                borderRadius: 2, textTransform: 'none', fontWeight: 600, fontSize: 13, px: 2,
                background: 'rgba(255,255,255,0.12)', color: '#fff',
                border: '1px solid rgba(255,255,255,0.2)', backdropFilter: 'blur(8px)',
                '&:hover': { background: 'rgba(255,255,255,0.2)' },
                '&.Mui-disabled': { color: 'rgba(255,255,255,0.35)', borderColor: 'rgba(255,255,255,0.1)' },
              }}
            >
              Export
            </Button>
            <NavBtn
              onClick={() => loadComments(page, filters)}
              disabled={loading}
              sx={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.18)', color: '#fff', '&:hover': { background: 'rgba(255,255,255,0.22)' } }}
            >
              <RefreshIcon sx={{ fontSize: 16 }} />
            </NavBtn>
            <NavBtn
              onClick={onClose}
              sx={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.18)', color: '#fff', '&:hover': { background: 'rgba(220,38,38,0.5)', borderColor: 'transparent' } }}
            >
              <CloseIcon sx={{ fontSize: 16 }} />
            </NavBtn>
          </Box>
        </PanelHeader>

        {/* ── Body ── */}
        <Box sx={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', p: '20px 24px', display: 'flex', flexDirection: 'column', gap: 2 }}>

          {/* Stats */}
          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={4}>
              <StatCard>
                <Box sx={{ width: 40, height: 40, borderRadius: 2, background: 'rgba(29,78,216,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <TableChartIcon sx={{ fontSize: 20, color: '#1d4ed8' }} />
                </Box>
                <Box>
                  <Typography sx={{ fontSize: 11, fontWeight: 600, color: txtSec, textTransform: 'uppercase', letterSpacing: 0.5 }}>Total Comments</Typography>
                  <Typography sx={{ fontSize: 22, fontWeight: 800, color: txtPri, lineHeight: 1.2 }}>{totalCount}</Typography>
                </Box>
              </StatCard>
            </Grid>
            <Grid item xs={12} sm={4}>
              <StatCard>
                <Box sx={{ width: 40, height: 40, borderRadius: 2, background: 'rgba(22,163,74,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <PeopleAltIcon sx={{ fontSize: 20, color: '#16a34a' }} />
                </Box>
                <Box>
                  <Typography sx={{ fontSize: 11, fontWeight: 600, color: txtSec, textTransform: 'uppercase', letterSpacing: 0.5 }}>Unique Leads</Typography>
                  <Typography sx={{ fontSize: 22, fontWeight: 800, color: txtPri, lineHeight: 1.2 }}>
                    {new Set(comments.map((c) => c.lead?._id).filter(Boolean)).size}
                  </Typography>
                </Box>
              </StatCard>
            </Grid>
            <Grid item xs={12} sm={4}>
              <StatCard>
                <Box sx={{ width: 40, height: 40, borderRadius: 2, background: 'rgba(249,115,22,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <AssessmentIcon sx={{ fontSize: 20, color: '#f97316' }} />
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontSize: 11, fontWeight: 600, color: txtSec, textTransform: 'uppercase', letterSpacing: 0.5, mb: 0.5 }}>By Stage</Typography>
                  <Box sx={{ display: 'flex', gap: 0.75, flexWrap: 'wrap' }}>
                    {stageSummary.length
                      ? stageSummary.map(([n, cnt]) => <StageTag key={n} chipcolor={getStageColor(n)}>{n} · {cnt}</StageTag>)
                      : <Typography sx={{ fontSize: 12, color: txtSec }}>—</Typography>}
                  </Box>
                </Box>
              </StatCard>
            </Grid>
          </Grid>

          {/* ── Filters ── */}
          <FilterPanel>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: filterOpen ? 2 : 0 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Box sx={{ width: 28, height: 28, borderRadius: 1.5, background: 'rgba(29,78,216,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <FilterListIcon sx={{ fontSize: 15, color: '#1d4ed8' }} />
                </Box>
                <Typography sx={{ fontSize: 14, fontWeight: 700, color: txtPri }}>Filters</Typography>
                {activeFilterCount > 0 && (
                  <Box sx={{ px: 1, py: 0.2, borderRadius: 10, background: '#1d4ed8', fontSize: 11, color: '#fff', fontWeight: 700 }}>
                    {activeFilterCount}
                  </Box>
                )}
              </Box>
              <Box sx={{ display: 'flex', gap: 1 }}>
                {activeFilterCount > 0 && (
                  <Button onClick={clearFilters} size="small" sx={{ textTransform: 'none', fontSize: 12, color: '#ef4444', borderRadius: 1.5, px: 1.5, minWidth: 0, '&:hover': { background: 'rgba(239,68,68,0.08)' } }}>
                    Clear all
                  </Button>
                )}
                <Button onClick={() => setFilterOpen(!filterOpen)} size="small" sx={{ textTransform: 'none', fontSize: 12, color: txtSec, borderRadius: 1.5, px: 1.5, minWidth: 0 }}>
                  {filterOpen ? 'Hide' : 'Show'}
                </Button>
              </Box>
            </Box>

            {filterOpen && (
              <Grid container spacing={1.5} alignItems="flex-end">

                {/* Search */}
                <Grid item xs={12} md={3}>
                  <Typography sx={{ fontSize: 11, fontWeight: 600, color: txtSec, mb: 0.5, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                    Lead Name / Phone
                  </Typography>
                  <TextField
                    fullWidth size="small"
                    placeholder="Search..."
                    value={tempFilters.searchTerm}
                    onChange={(e) => handleFilterChange('searchTerm', e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon sx={{ fontSize: 15, color: '#94a3b8' }} />
                        </InputAdornment>
                      ),
                      endAdornment: tempFilters.searchTerm && (
                        <InputAdornment position="end">
                          <IconButton size="small" onClick={() => handleFilterChange('searchTerm', '')}>
                            <ClearIcon sx={{ fontSize: 13 }} />
                          </IconButton>
                        </InputAdornment>
                      ),
                      sx: { borderRadius: '8px', fontSize: 13 },
                    }}
                    sx={inputSx(isDark)}
                  />
                </Grid>

                {/* Stage — SearchableDropdown */}
                <Grid item xs={12} md={2}>
                  <Typography sx={{ fontSize: 11, fontWeight: 600, color: txtSec, mb: 0.5, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                    Stage
                  </Typography>
                  <SearchableDropdown
                    value={tempFilters.stage || ''}
                    onChange={(val) => handleFilterChange('stage', val)}
                    options={stageOptions}
                    placeholder="All Stages"
                    isDark={isDark}
                    accentColor={getStageColor(stagesarray.find((s) => s._id === tempFilters.stage)?.name)}
                  />
                </Grid>

                {/* Sales — SearchableDropdown */}
                <Grid item xs={12} md={2.5}>
                  <Typography sx={{ fontSize: 11, fontWeight: 600, color: txtSec, mb: 0.5, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                    Sales (By)
                  </Typography>
                  <SearchableDropdown
                    value={tempFilters.salesUserId}
                    onChange={(val) => handleFilterChange('salesUserId', val)}
                    options={salesOptions}
                    placeholder="All Sales"
                    isDark={isDark}
                    accentColor="#0f766e"
                  />
                </Grid>

                {/* Developer — SearchableDropdown */}
                <Grid item xs={12} md={2.5}>
                  <Typography sx={{ fontSize: 11, fontWeight: 600, color: txtSec, mb: 0.5, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                    Developer
                  </Typography>
                  <SearchableDropdown
                    value={tempFilters.salesdeveloperName}
                    onChange={(val) => handleFilterChange('salesdeveloperName', val)}
                    options={devOptions}
                    placeholder="All Developers"
                    isDark={isDark}
                    accentColor="#7c3aed"
                  />
                </Grid>

                {/* From */}
                <Grid item xs={6} md={1}>
                  <Typography sx={{ fontSize: 11, fontWeight: 600, color: txtSec, mb: 0.5, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                    From
                  </Typography>
                  <TextField
                    fullWidth size="small" type="date"
                    value={tempFilters.createdFrom}
                    onChange={(e) => handleFilterChange('createdFrom', e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    sx={inputSx(isDark)}
                    InputProps={{ sx: { borderRadius: '8px', fontSize: 12 } }}
                  />
                </Grid>

                {/* To */}
                <Grid item xs={6} md={1}>
                  <Typography sx={{ fontSize: 11, fontWeight: 600, color: txtSec, mb: 0.5, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                    To
                  </Typography>
                  <TextField
                    fullWidth size="small" type="date"
                    value={tempFilters.createdTo}
                    onChange={(e) => handleFilterChange('createdTo', e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    sx={inputSx(isDark)}
                    InputProps={{ sx: { borderRadius: '8px', fontSize: 12 } }}
                  />
                </Grid>

                {/* Apply */}
                <Grid item xs={12} md="auto">
                  <Button
                    variant="contained"
                    onClick={handleApplyFilters}
                    sx={{
                      borderRadius: 2, textTransform: 'none', fontWeight: 700, fontSize: 13, px: 3, height: 40,
                      background: 'linear-gradient(135deg, #1e3a8a, #1d4ed8)',
                      boxShadow: '0 2px 10px rgba(29,78,216,0.3)',
                      '&:hover': { background: 'linear-gradient(135deg, #1e3a8a, #2563eb)', boxShadow: '0 4px 16px rgba(29,78,216,0.4)' },
                    }}
                  >
                    Apply
                  </Button>
                </Grid>
              </Grid>
            )}
          </FilterPanel>

          {/* ── Table Card ── */}
          <Box sx={{ background: cardBg, borderRadius: 3, border: `1px solid ${border}`, overflow: 'hidden', display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>

            {/* Table header */}
            <Box sx={{ px: 2.5, py: 1.75, display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: `1px solid ${border}` }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Typography sx={{ fontSize: 15, fontWeight: 700, color: txtPri }}>Comments</Typography>
                <Box sx={{ px: 1.25, py: 0.25, borderRadius: 10, background: isDark ? 'rgba(29,78,216,0.15)' : '#eff6ff', color: '#1d4ed8', fontSize: 11, fontWeight: 700, letterSpacing: 0.4 }}>
                  {totalCount} results
                </Box>
              </Box>
              <Typography sx={{ fontSize: 12, color: txtSec }}>Page {page} of {totalPages}</Typography>
            </Box>

            {loading && (
              <LinearProgress sx={{ height: 2, '& .MuiLinearProgress-bar': { background: 'linear-gradient(90deg, #1e3a8a, #1d4ed8)' } }} />
            )}

            {/* Empty state */}
            {!loading && !comments.length && (
              <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', py: 8, gap: 1.5 }}>
                <Box sx={{ width: 64, height: 64, borderRadius: '50%', background: isDark ? 'rgba(255,255,255,0.04)' : '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <CommentIcon sx={{ fontSize: 28, color: txtSec }} />
                </Box>
                <Typography sx={{ fontSize: 15, fontWeight: 600, color: txtPri }}>No comments found</Typography>
                <Typography sx={{ fontSize: 13, color: txtSec }}>Try adjusting your filters</Typography>
                <Button
                  variant="outlined"
                  startIcon={<RefreshIcon />}
                  onClick={() => loadComments(1, filters)}
                  sx={{ mt: 1, borderRadius: 2, textTransform: 'none', borderColor: '#1d4ed8', color: '#1d4ed8', '&:hover': { background: 'rgba(29,78,216,0.06)' } }}
                >
                  Refresh
                </Button>
              </Box>
            )}

            {/* Table */}
            {!loading && !!comments.length && (
              <TableContainer sx={{ flex: 1, overflow: 'auto' }}>
                <Table size="small" sx={{ tableLayout: 'fixed' }}>
                  <TableHead>
                    <TableRow sx={{ background: isDark ? 'rgba(255,255,255,0.02)' : '#f8fafc' }}>
                      {['DATE', 'LEAD', 'STAGE', 'COMMENT', 'SALES', 'DEVELOPER'].map((h) => (
                        <TableCell key={h} sx={{ fontSize: 10, fontWeight: 800, letterSpacing: 0.8, color: isDark ? '#475569' : '#94a3b8', textTransform: 'uppercase', borderBottom: `2px solid ${isDark ? 'rgba(255,255,255,0.06)' : '#e2e8f0'}`, py: 1.5, px: 2.5 }}>
                          {h}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {comments.map((c, i) => (
                      <TableRow
                        key={c._id || i}
                        sx={{
                          borderBottom: `1px solid ${isDark ? 'rgba(255,255,255,0.04)' : '#f1f5f9'}`,
                          '&:hover': { background: isDark ? 'rgba(29,78,216,0.07)' : 'rgba(29,78,216,0.03)' },
                          transition: 'background 0.12s ease',
                        }}
                      >
                        {/* Date */}
                        <TableCell sx={{ px: 2.5, py: 2 }}>
                          <Typography sx={{ fontSize: 13, fontWeight: 700, color: txtPri }}>
                            {c.createdAt ? moment(c.createdAt).format('DD MMM YYYY') : '—'}
                          </Typography>
                          <Typography sx={{ fontSize: 11, color: txtSec, mt: 0.2 }}>
                            {c.createdAt ? moment(c.createdAt).format('hh:mm A') : ''}
                          </Typography>
                        </TableCell>

                        {/* Lead */}
                        <TableCell sx={{ px: 2.5, py: 2 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            <Avatar sx={{ width: 34, height: 34, fontSize: 13, fontWeight: 800, background: 'linear-gradient(135deg, #1e3a8a, #1d4ed8)', flexShrink: 0 }}>
                              {c.lead?.name?.charAt(0)?.toUpperCase() || '?'}
                            </Avatar>
                            <Box>
                              <Typography sx={{ fontSize: 13, fontWeight: 700, color: txtPri }}>{c.lead?.name || 'N/A'}</Typography>
                              {c.lead?.phone && <Typography sx={{ fontSize: 11, color: txtSec }}>{c.lead.phone}</Typography>}
                            </Box>
                          </Box>
                        </TableCell>

                        {/* Stage */}
                        <TableCell sx={{ px: 2.5, py: 2 }}>
                          <StageTag chipcolor={getStageColor(c.stage?.name)}>{c.stage?.name || 'N/A'}</StageTag>
                        </TableCell>

                        {/* Comment */}
                        <TableCell sx={{ px: 2.5, py: 2 }}>
                          <Tooltip
                            title={c.comment || ''}
                            arrow placement="top"
                            componentsProps={{ tooltip: { sx: { maxWidth: 320, fontSize: 12, borderRadius: 2 } } }}
                          >
                            <Typography sx={{ fontSize: 13, color: txtSec, fontStyle: 'italic', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 240, cursor: 'help' }}>
                              {c.comment ? `"${c.comment}"` : '—'}
                            </Typography>
                          </Tooltip>
                        </TableCell>

                        {/* Sales */}
                        <TableCell sx={{ px: 2.5, py: 2 }}>
                          {c.commentBy?.name
                            ? (
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Avatar sx={{ width: 26, height: 26, fontSize: 11, fontWeight: 700, bgcolor: '#0f766e' }}>
                                  {c.commentBy.name.charAt(0)}
                                </Avatar>
                                <Typography sx={{ fontSize: 13, fontWeight: 500, color: txtPri }}>{c.commentBy.name}</Typography>
                              </Box>
                            )
                            : <Typography sx={{ fontSize: 13, color: txtSec }}>—</Typography>}
                        </TableCell>

                        {/* Developer */}
                        <TableCell sx={{ px: 2.5, py: 2 }}>
                          {c.salesdeveloperName
                            ? (
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Avatar sx={{ width: 26, height: 26, fontSize: 11, fontWeight: 700, bgcolor: '#7c3aed' }}>
                                  {c.salesdeveloperName.charAt(0)}
                                </Avatar>
                                <Typography sx={{ fontSize: 13, fontWeight: 500, color: txtPri }}>{c.salesdeveloperName}</Typography>
                              </Box>
                            )
                            : <Typography sx={{ fontSize: 13, color: txtSec }}>—</Typography>}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            {/* ── Pagination ── */}
            {!loading && !!comments.length && (
              <Box sx={{
                px: 2.5, py: 1.5,
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                flexWrap: 'wrap', gap: 2,
                borderTop: `1px solid ${border}`,
                background: isDark ? 'rgba(255,255,255,0.02)' : '#fafbfd',
              }}>
                <Typography sx={{ fontSize: 12, color: txtSec }}>
                  Showing{' '}
                  <Box component="span" sx={{ fontWeight: 700, color: txtPri }}>
                    {Math.min((page - 1) * rowsPerPage + 1, totalCount)}–{Math.min(page * rowsPerPage, totalCount)}
                  </Box>
                  {' '}of{' '}
                  <Box component="span" sx={{ fontWeight: 700, color: txtPri }}>{totalCount}</Box>
                </Typography>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <NavBtn onClick={() => handlePageChange(1)}          disabled={page === 1}>        <FirstPageIcon sx={{ fontSize: 13 }} /></NavBtn>
                  <NavBtn onClick={() => handlePageChange(page - 1)}   disabled={!hasPrevPage}>      <KeyboardArrowLeftIcon sx={{ fontSize: 15 }} /></NavBtn>
                  {getPageNumbers().map((n, idx) =>
                    n === '...'
                      ? <Typography key={`d${idx}`} sx={{ px: 0.5, fontSize: 13, color: txtSec }}>···</Typography>
                      : <PgBtn key={n} isactive={String(page === n)} onClick={() => handlePageChange(n)}>{n}</PgBtn>
                  )}
                  <NavBtn onClick={() => handlePageChange(page + 1)}   disabled={!hasNextPage}>      <KeyboardArrowRightIcon sx={{ fontSize: 15 }} /></NavBtn>
                  <NavBtn onClick={() => handlePageChange(totalPages)} disabled={page === totalPages}><LastPageIcon sx={{ fontSize: 13 }} /></NavBtn>
                </Box>

                <FormControl size="small" sx={{ minWidth: 110 }}>
                  <Select
                    value={rowsPerPage}
                    onChange={handleRowsPerPageChange}
                    displayEmpty
                    sx={{ borderRadius: 2, fontSize: 12, height: 32, ...selectSx(isDark) }}
                    MenuProps={menuProps}
                  >
                    {[10, 25, 50, 100].map((n) => (
                      <MenuItem key={n} value={n} sx={{ fontSize: 13 }}>{n} / page</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};